import React from 'react';

import 'RLX/Style/Buttons.scss';

class Submit extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { className, when, children } = this.props;
    const type = 'submit';
    const props = { type, className, children };
    if (!when && typeof when !== 'undefined') props.disabled = true;

    return (<button {...props} />);
  }
};

export default Submit;



// WEBPACK FOOTER //
// ./client/RLX/Forms/Submit.jsx